import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
const LINKS = [{
  icon: MailIcon,
  label: 'Support via email'
}, {
  icon: InstagramIcon,
  label: 'Instagram'
}, {
  icon: GlobeIcon,
  label: 'Official website'
}];
export function SiteFooter() {
  return <footer className="w-full border-t border-line bg-ink" data-id="element-235" data-mp="3hig1e6ey8cbn">
      <div className="mx-auto max-w-5xl px-4 py-11 text-center sm:px-5 sm:py-14" data-id="element-236" data-mp="3hhwtzjmxd6bv">
        <p className="font-display text-xl font-semibold text-cream sm:text-2xl" data-id="element-237" data-mp="3dhmf1hh5n5kv">
          The Perfect Dog Method™
        </p>
        <p className="mt-3 text-sm text-cream/70" data-id="element-238" data-mp="38junwpoc3nhq">
          The simple 30-day system for a calmer, more obedient companion.
        </p>
        <p className="mx-auto mt-2 max-w-md font-display text-sm italic text-terracotta-light" data-id="element-239" data-mp="2yju3t1in53ch">
          Because loving your dog shouldn’t feel this exhausting.
        </p>

        <ul className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3 sm:mt-8 sm:gap-x-7" data-id="element-240" data-mp="11oxvlv1xui54">
          {LINKS.map(({
          icon: Icon,
          label
        }) => <li key={label} data-id="element-241" data-mp="15ptwct8hlswf">
              <a href="#offer" className="flex items-center gap-2 text-xs font-medium text-cream/60 transition-colors duration-150 ease-out hover:text-terracotta-light" data-id="element-242" data-mp="15pk6r6rctnr9">
                <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-243" data-mp="vv1ydoazt414" />
                <span className="whitespace-nowrap" data-id="element-244" data-mp="10s0s45qqv8ys">{label}</span>
              </a>
            </li>)}
        </ul>

        <p className="mt-9 border-t border-white/10 pt-6 text-[9px] font-bold uppercase leading-relaxed tracking-[0.14em] text-cream/40 sm:mt-10 sm:pt-7 sm:text-[10px] sm:tracking-[0.18em]" data-id="element-245" data-mp="1ojpez6ksr58c">
          One-time payment · Secure SSL encryption · Instant digital delivery
        </p>
      </div>
    </footer>;
}